export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "greeting": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Bonjour ", _interpolate(_named("name")), " 👋"])},
        "global_view": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vue globale"])},
        "challenge": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Challenge"])}
      },
      "en": {
        "greeting": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Hello ", _interpolate(_named("name")), " 👋"])},
        "global_view": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Global view"])},
        "challenge": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Challenge"])}
      }
    }
  })
}
